<template>
  <div>
    <div class="col-12 col-xl-12 featured-job-row m-auto">
      <no-ssr>
        <swiper :options="swiperOptions">
            <swiper-slide v-for="item in items" :key="item.id" class="">
              <div class="clickable">
                <a :href="`/job/${getFullSlug(item.jobtitletext,item.id)}`" target="_blank">
                  <div :id="item.id" class="cp-hp-job-card">
                    <div class="title">
                      {{ item.jobtitletext }}
                    </div>
                    <div class="company">
                      {{ item.displayname }}
                    </div>
                    <div class="ind">
                      <div class="bubble bg-cir_industry">
                        <i class="cpi cpi-briefcase" />
                      </div>
                      <div class="indText">
                        {{ languageHandler(item.industrydesc) }}
                      </div>
                    </div>
                    <div class="view">
                      {{ cpLang('jd.view') }}
                    </div>
                  </div>
                </a>
              </div>
            </swiper-slide>
        </swiper>
      </no-ssr>
      <div class="d-none d-lg-block">
        <div id="fj-left" slot="button-prev" class="clickable agile-btn left d-none d-sm-block">
          <img width="100%" height="100%" src="/asset/image/icon/ios-arrow-forward.svg" alt="">
        </div>
        <div id="fj-right" slot="button-next" class="clickable agile-btn right d-none d-sm-block">
          <img width="100%" height="100%" src="/asset/image/icon/ios-arrow-forward.svg" alt="">
        </div>
      </div>
    </div>
</div>
</template>

<script>
import commonHelper from '~/assets/js/commonHelper.js'

export default {
  name: 'FeaturedJobs',
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: function() {
    return {
      showCarousel: false
    }
  },
  computed: {
    swiperOptions() {
      return {
        slidesPerView: 4,
        setWrapperSize: true,
        autoHeight: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '#fj-right',
          prevEl: '#fj-left'
        },
        loop: true,
        breakpoints: {
          1366: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
            navigation: false
          },
          414: {
            slidesPerView: 1.3,
            spaceBetween: 10,
            navigation: false
          },
          0: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            navigation: false
          }
        }
      }
    }
  },
  methods: {
    languageHandler(item) {
      return commonHelper.languageHandler(item)
    },
    getFullSlug(title, id) {
      const fullSlug = commonHelper.getSlug(title) + '-' + id
      return fullSlug
    }
  }
}
</script>

<style lang="scss">

</style>
